export default {
      id: "shopping-cart-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#shopping-cart-usage",
      toString: function () {
        return this.url;
      }
    }